import React from 'react';

import { Icon } from '@/components/memo';
import { DentistNotification } from '@/data/DentistNotifications';
import {
  NOTIFICATION_ACTIONS,
  NOTIFICATION_CATEGORIES,
  NOTIFICATION_CATEGORY_IDENTIFIERS,
  NOTIFICATION_TITLES
} from '@/utils/constants';
import { formatNotificationTimestamp } from '@/utils/helpers/formatNotificationTimestamp';
import kebabCase from '@/utils/helpers/kebabCase';
import { NotificationCategory } from '@/utils/types';
import { chevronForwardOutline } from 'ionicons/icons';

import './NotificationItem.css';

interface NotificationItemProps {
  notification: DentistNotification;
  notificationCategory: NotificationCategory;
  isUnread?: boolean;
  onClick: (
    notification: DentistNotification,
    category: NotificationCategory
  ) => void;
}

const NotificationItem: React.FC<NotificationItemProps> = ({
  notification,
  notificationCategory,
  isUnread = false,
  onClick
}) => {
  const notificationTitle = NOTIFICATION_TITLES[notificationCategory];
  const notificationAction = NOTIFICATION_ACTIONS[notificationCategory];

  return (
    <div
      className="notification-item"
      onClick={() => onClick(notification, notificationCategory)}
    >
      <div className="notification-item__information">
        <p
          className={`notification-item__category notification-item__category--${kebabCase(notificationCategory)}`}
        >
          {notificationCategory.replace('_', ' ').toUpperCase()}
        </p>
        <p className="notification-item__timestamp">
          {formatNotificationTimestamp(notification.created_at)}
        </p>
      </div>
      <div>
        <div className="notification-item__title-container">
          {isUnread && <div className="notification-item__unread-badge"></div>}
          <p className="notification-item__title">{notificationTitle}</p>
        </div>
        <p className="notification-item__message">
          {notification.message.replace(
            NOTIFICATION_CATEGORY_IDENTIFIERS.REMINDER,
            ''
          )}
        </p>
      </div>
      <div className="notification-item__action">
        <p className="notification-item__action-text">{notificationAction}</p>
        <Icon
          icon={chevronForwardOutline}
          className="notification-item__action-icon"
        />
      </div>
    </div>
  );
};

export default NotificationItem;
